import React, { useMemo } from "react";
import { BarChart3, Train, AlertTriangle, AlertCircle } from "lucide-react";

const SummaryReport = ({ responseData }) => {
  const stats = useMemo(() => {
    if (!responseData || !responseData.trainDataBySiteDb) {
      return { totalTrains: 0, totalAxles: 0, totalAlarms: 0, totalWarnings: 0 };
    }

    let totalTrains = 0;
    let totalAxles = 0;
    let totalAlarms = 0;
    let totalWarnings = 0;

    for (const trainList of Object.values(responseData.trainDataBySiteDb)) {
      if (Array.isArray(trainList)) {
        totalTrains += trainList.length;
        for (const train of trainList) {
          totalAxles += train.TotalNoOfAxles || 0;
          if (train.AlarmType === "hasAlarm") totalAlarms++;
          if (train.WarningType === "hasWarning") totalWarnings++;
        }
      }
    }

    return { totalTrains, totalAxles, totalAlarms, totalWarnings };
  }, [responseData]);

  if (!responseData || !responseData.trainDataBySiteDb) return null;

  const summaryCards = [
    {
      title: "Total Trains",
      value: stats.totalTrains,
      icon: Train,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      title: "Total Axles",
      value: stats.totalAxles,
      icon: BarChart3,
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
    {
      title: "Total Alarms",
      value: stats.totalAlarms,
      icon: AlertTriangle,
      color: "text-red-600",
      bgColor: "bg-red-50",
    },
    {
      title: "Total Warnings",
      value: stats.totalWarnings,
      icon: AlertCircle,
      color: "text-yellow-600",
      bgColor: "bg-yellow-50",
    },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto mt-2">
      {/* Summary Cards Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-1.5">
        {summaryCards.map((card, index) => {
          const IconComponent = card.icon;
          return (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-md shadow-sm hover:shadow transition-shadow duration-200 p-2"
            >
              <div className="flex items-center justify-between space-x-2">
                <div className="flex-1 min-w-0">
                  <h3 className="text-[11px] font-medium text-gray-600 mb-0.5 truncate">
                    {card.title}
                  </h3>
                  <p className="text-xl font-semibold text-gray-900 leading-snug">
                    {card.value.toLocaleString()}
                  </p>
                </div>
                <div className={`${card.bgColor} p-1 rounded-md`}>
                  <IconComponent className={`w-4 h-4 ${card.color}`} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SummaryReport;